import AppConfiguration from "dataProvider/config";
import BaseService from "./BaseService";

export default class WmsService extends BaseService {
  constructor() {
    super(AppConfiguration.apiBaseWms, "api");
  }
  deleteUserRole(id) {
    let path = `user-role/${id}/`;
    return this.doDelete(path);
  }

  getUsers(params) {
    let path = `user`;
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }
  createUserRole(data) {
    let path = `user-role/`;
    return this.doPost(path, data);
  }
  updateUserRole(data, id) {
    let path = `user-role/${id}/`;
    return this.doPut(path, data);
  }
  getUserRoles(params) {
    let path = `user-role`;
    const configs = this.getConfigs({ params });
    return this.doGet(path, configs);
  }
  getConfigConstance() {
    let path = `config/constance`;
    const configs = this.getConfigs({});
    return this.doGet(path, configs);
  }
  updateConfigConstance(data) {
    let path = `config/update-constance/`;
    return this.doPut(path, data);
  }
  getDestination(params) {
    let path = `destination/`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelSortingPlanDetail(id) {
    const path = `wheel/plan/${id}/`;
    return this.doGet(path);
  }

  getWheelChuteList(params) {
    const path = "wheel/chute/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelChuteRejectList(id) {
    const path = `wheel/${id}/chute-reject/`;
    return this.doGet(path);
  }

  createWheelChute(data) {
    const path = "wheel/chute/";
    return this.doPost(path, data);
  }

  deleteWheelChute(id) {
    let path = `wheel/chute/${id}/`;
    return this.doDelete(path);
  }

  updateWheelChute(id, data) {
    let path = `wheel/chute/${id}/`;
    return this.doPut(path, data);
  }

  createWheelPlan(data) {
    const path = "wheel/plan/";
    return this.doPost(path, data);
  }

  updateWheelPlan(id, data) {
    let path = `wheel/plan/${id}/`;
    return this.doPut(path, data);
  }

  deleteWheelPlan(id) {
    let path = `wheel/plan/${id}/`;
    return this.doDelete(path);
  }

  activeWheelPlan(id) {
    let path = `wheel/plan/${id}/active/`;
    return this.doGet(path);
  }
  inactiveWheelPlan(id) {
    let path = `wheel/plan/${id}/inactive/`;
    return this.doGet(path);
  }
  copyWheelPlan(id) {
    let path = `wheel/plan/${id}/copy/`;
    return this.doPost(path);
  }

  deleteWheelCarrier(id) {
    let path = `wheel/carrier/${id}`;
    return this.doDelete(path);
  }

  deleteWheelInduction(id) {
    let path = `wheel/induction/${id}`;
    return this.doDelete(path);
  }

  syncWheelPlan(id) {
    let path = `wheel/plan/${id}/sync/`;
    return this.doGet(path);
  }

  getWheelPlanMissConfig(id) {
    const path = `wheel/plan/${id}/miss-station/`;
    return this.doGet(path);
  }

  getWheelChuteConfigs(params) {
    const path = `wheel/plan-chute/`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createWheelChuteConfig(data) {
    const path = `wheel/plan-chute/`;
    return this.doPost(path, data);
  }
  copyWheel(data) {
    const path = `wheel/plan-chute/wheel-clone/`;
    return this.doPost(path, data);
  }
  copyInduction(data) {
    const path = `wheel/plan-chute/induction-clone/`;
    return this.doPost(path, data);
  }
  deleteInduction(params) {
    const path = `wheel/plan-chute/induction`;
    const configs = this.getConfigs({
      params
    });
    return this.doDelete(path, configs);
  }

  updateWheelChuteConfig(id, data) {
    let path = `wheel/plan-chute/${id}/`;
    return this.doPut(path, data);
  }
  updateWheelPlanChuteBatch(data) {
    let path = `wheel/plan-chute/batch/`;
    return this.doPost(path, data);
  }

  deleteWheelChuteConfig(id) {
    let path = `wheel/plan-chute/${id}/`;
    return this.doDelete(path);
  }

  /**
   * lấy danh sách Wheel Plan
   * @returns
   */
  getWheelPlans(params) {
    const path = "wheel/plan/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * Thêm mới Wheel operation-config
   * @returns
   */
  addWheelOperationConfig(data) {
    const path = "wheel/operation-config/";
    return this.doPost(path, data);
  }

  /**
   * Thêm mới Wheel operation-config
   * @returns
   */
  editWheelOperationConfig(data) {
    const path = `wheel/operation-config/${data.id}/`;
    return this.doPut(path, data);
  }

  /**
   * Thêm mới Wheel Carrier
   * @returns
   */
  addWheelCarrier(data) {
    const path = "wheel/carrier/";
    return this.doPost(path, data);
  }

  /**
   * Cập nhật Wheel Carrier
   * @returns
   */
  editWheelCarrier(data) {
    const path = `wheel/carrier/${data.id}/`;
    delete data.id;
    return this.doPut(path, data);
  }

  /**
   * Thêm mới Wheel Induction
   * @returns
   */
  addWheelInduction(data) {
    const path = "wheel/induction/";
    return this.doPost(path, data);
  }

  /**
   * Cập nhật Wheel Induction
   * @returns
   */
  editWheelInduction(data) {
    const path = `wheel/induction/${data.id}/`;
    delete data.id;
    return this.doPut(path, data);
  }

  /**
   * Thêm mới Wheel Chute
   * @returns
   */
  addWheelChute(data) {
    const path = "wheel/chute/";
    return this.doPost(path, data);
  }

  /**
   * Cập nhật Wheel Chute
   * @returns
   */
  editWheelChute(data) {
    const path = `wheel/chute/${data.id}/`;
    delete data.id;
    return this.doPut(path, data);
  }

  /**
   * Cập nhật Wheel Chute
   * @returns
   */
  editWheelInitChute(data) {
    const path = `wheel/cage/init-chute/`;
    return this.doPost(path, data);
  }

  /**
   * lấy danh sách Wheel Chute
   * @returns
   */
  getWheelChutes(params) {
    const path = "wheel/chute/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * lấy danh sách Wheel Induction
   * @returns
   */
  getWheelInductions(params) {
    const path = "wheel/induction/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  /**
   * lấy danh sách Wheel Cage
   * @returns
   */
  getWheelCages(params) {
    const path = "wheel/cage/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getWheelOperationConfigList(params) {
    const path = "wheel/operation-config/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * lấy danh sách DeviceSorting
   * @returns
   */
  getSortingDevices() {
    const path = "device-sorting/";
    const configs = this.getConfigs({
      params: { limit: 1000 }
    });
    return this.doGet(path, configs);
  }

  getCrossbeltSortingPlanDetail(id) {
    const path = `crossbelt/plan/${id}/`;
    return this.doGet(path);
  }

  getCrossbeltChuteList(params) {
    const path = "crossbelt/chute/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getCrossbeltChuteRejectList(id) {
    const path = `crossbelt/${id}/chute-reject/`;
    return this.doGet(path);
  }

  createCrossbeltChute(data) {
    const path = "crossbelt/chute/";
    return this.doPost(path, data);
  }

  deleteCrossbeltChute(id) {
    let path = `crossbelt/chute/${id}/`;
    return this.doDelete(path);
  }

  updateCrossbeltChute(id, data) {
    let path = `crossbelt/chute/${id}/`;
    return this.doPut(path, data);
  }

  createCrossbeltPlan(data) {
    const path = "crossbelt/plan/";
    return this.doPost(path, data);
  }

  updateCrossbeltPlan(id, data) {
    let path = `crossbelt/plan/${id}/`;
    return this.doPut(path, data);
  }

  deleteCrossbeltPlan(id) {
    let path = `crossbelt/plan/${id}/`;
    return this.doDelete(path);
  }

  activeCrossbeltPlan(id) {
    let path = `crossbelt/plan/${id}/active/`;
    return this.doPut(path);
  }
  copyCrossbeltPlan(id) {
    let path = `crossbelt/plan/${id}/copy/`;
    return this.doPost(path);
  }

  deleteCrossbeltCarrier(id) {
    let path = `crossbelt/carrier/${id}`;
    return this.doDelete(path);
  }

  deleteCrossbeltInduction(id) {
    let path = `crossbelt/induction/${id}`;
    return this.doDelete(path);
  }

  syncCrossbeltPlan(id) {
    let path = `crossbelt/plan/${id}/sync/`;
    return this.doGet(path);
  }

  getCrossbeltPlanMissConfig(id) {
    const path = `crossbelt/plan/${id}/miss-station/`;
    return this.doGet(path);
  }

  getCrossbeltChuteConfigs(params) {
    const path = `crossbelt/plan-chute/`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createCrossbeltChuteConfig(data) {
    const path = `crossbelt/plan-chute/`;
    return this.doPost(path, data);
  }

  updateCrossbeltChuteConfig(id, data) {
    let path = `crossbelt/plan-chute/${id}/`;
    return this.doPut(path, data);
  }

  deleteCrossbeltChuteConfig(id) {
    let path = `crossbelt/plan-chute/${id}/`;
    return this.doDelete(path);
  }

  /**
   * lấy danh sách Crossbelt Plan
   * @returns
   */
  getCrossbeltPlans(params) {
    const path = "crossbelt/plan/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * Thêm mới Crossbelt operation-config
   * @returns
   */
  addCrossbeltOperationConfig(data) {
    const path = "crossbelt/operation-config/";
    return this.doPost(path, data);
  }

  /**
   * Thêm mới Crossbelt Carrier
   * @returns
   */
  addCrossbeltCarrier(data) {
    const path = "crossbelt/carrier/";
    return this.doPost(path, data);
  }

  /**
   * Cập nhật Crossbelt Carrier
   * @returns
   */
  editCrossbeltCarrier(data) {
    const path = `crossbelt/carrier/${data.id}/`;
    delete data.id;
    return this.doPut(path, data);
  }

  /**
   * Thêm mới Crossbelt Induction
   * @returns
   */
  addCrossbeltInduction(data) {
    const path = "crossbelt/induction/";
    return this.doPost(path, data);
  }

  /**
   * Cập nhật Crossbelt Induction
   * @returns
   */
  editCrossbeltInduction(data) {
    const path = `crossbelt/induction/${data.id}/`;
    delete data.id;
    return this.doPut(path, data);
  }

  /**
   * Thêm mới Crossbelt Chute
   * @returns
   */
  addCrossbeltChute(data) {
    const path = "crossbelt/chute/";
    return this.doPost(path, data);
  }

  /**
   * Cập nhật Crossbelt Chute
   * @returns
   */
  editCrossbeltChute(data) {
    const path = `crossbelt/chute/${data.id}/`;
    delete data.id;
    return this.doPut(path, data);
  }

  /**
   * lấy danh sách Crossbelt Chute
   * @returns
   */
  getCrossbeltChutes(params) {
    const path = "crossbelt/chute/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * lấy danh sách Crossbelt Induction
   * @returns
   */
  getCrossbeltInductions(params) {
    const path = "crossbelt/induction/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
  /**
   * lấy danh sách Crossbelt Carrier
   * @returns
   */
  getCrossbeltCarrier(params) {
    const path = "crossbelt/carrier/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy data cho biểu đồ tỉ lệ rã bao của crossbelt
   * @returns
   */
  getCrossbeltInboundRate(type, stationId) {
    const path = "crossbelt/statistics/inbound-rate/";
    const configs = this.getConfigs({
      params: { type, station_id: stationId }
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy data cho biểu đồ tỉ lệ đọc scanner của crossbelt
   * @returns
   */
  getCrossbeltScannerRate(type, stationId) {
    const path = "crossbelt/statistics/scanner-rate/";
    const configs = this.getConfigs({
      params: { type, station_id: stationId }
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy data cho biểu đồ công suất qua crossbelt
   * @param {*} type
   * @param {*} stationId
   * @returns
   */
  getCrossbeltStatisticsInduction(type, stationId) {
    const path = "crossbelt/statistics/induction/";
    const configs = this.getConfigs({
      params: { type, station_id: stationId }
    });
    return this.doGet(path, configs);
  }
  /**
   * Lấy data cho biểu đồ công suất qua crossbelt
   * @param {*} type
   * @param {*} stationId
   * @returns
   */
  getCrossbeltStatisticsSorting(type, stationId) {
    const path = "crossbelt/statistics/sorting/";
    const configs = this.getConfigs({
      params: { type, station_id: stationId }
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy data cho biểu đồ tỉ lệ đọc sorting của wheel
   * @returns
   */
  getWheelSortingRate(type, deviceSortingId) {
    const path = "wheel/statistics/sorting-rate/";
    const configs = this.getConfigs({
      params: { type, device_sorting_id: deviceSortingId }
    });
    return this.doGet(path, configs);
  }

  /**
   * Lấy data cho biểu đồ công suất qua wheel
   * @param {*} type
   * @param {*} stationId
   * @returns
   */
  getWheelStatisticsInduction(type, deviceSortingId) {
    const path = "wheel/statistics/induction/";
    const configs = this.getConfigs({
      params: { type, device_sorting_id: deviceSortingId }
    });
    return this.doGet(path, configs);
  }
  /**
   * Lấy data cho biểu đồ công suất qua wheel
   * @param {*} type
   * @param {*} stationId
   * @returns
   */
  getWheelStatisticsSorting(type, deviceSortingId) {
    const path = "wheel/statistics/sorting/";
    const configs = this.getConfigs({
      params: { type, device_sorting_id: deviceSortingId }
    });
    return this.doGet(path, configs);
  }

  getCrossbeltOperationConfigList(params) {
    const path = "crossbelt/operation-config/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getShopReport(params) {
    const path = "mobile/shop-package-reports/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  deleteShopReport(id) {
    let path = `mobile/shop-report/?id=${id}`;
    return this.doDelete(path);
  }

  createShopReport(data) {
    let path = "shop-report/save/";
    return this.doPost(path, data);
  }

  getWmsProvince(params) {
    const path = "province/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getDeviceSorting(params) {
    const path = "device-sorting/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getBombayStatisticScannerRate(params) {
    const path = "bombay/statistics/scanner-rate/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getBombayStatisticPower(params) {
    const path = "bombay/statistics/induction/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getBombayStatisticTotal(params) {
    const path = "bombay/statistics/sorting";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Bombay Chute
  getBombayChuteList(params) {
    const path = "bombay/chute/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getBombayChuteRejectList(id) {
    const path = `bombay/${id}/chute-reject/`;
    return this.doGet(path);
  }

  createBombayChute(data) {
    const path = "bombay/chute/";
    return this.doPost(path, data);
  }

  deleteBombayChute(id) {
    let path = `bombay/chute/${id}`;
    return this.doDelete(path);
  }

  updateBombayChute(id, data) {
    let path = `bombay/chute/${id}/`;
    return this.doPut(path, data);
  }

  // Bombay Carrier
  getBombayCarrierList(params) {
    const path = "bombay/carrier/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createBombayCarrier(data) {
    const path = "bombay/carrier/";
    return this.doPost(path, data);
  }

  deleteBombayCarrier(id) {
    let path = `bombay/carrier/${id}`;
    return this.doDelete(path);
  }

  updateBombayCarrier(id, data) {
    let path = `bombay/carrier/${id}/`;
    return this.doPut(path, data);
  }
  // Bombay Induction
  getBombayInductionList(params) {
    const path = "bombay/induction/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createBombayInduction(data) {
    const path = "bombay/induction/";
    return this.doPost(path, data);
  }

  deleteBombayInduction(id) {
    let path = `bombay/induction/${id}`;
    return this.doDelete(path);
  }

  updateBombayInduction(id, data) {
    let path = `bombay/induction/${id}/`;
    return this.doPut(path, data);
  }

  // Bombay operation config
  getBombayOperationConfigList(params) {
    const path = "bombay/operation-config/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createBombayOperationConfig(data) {
    const path = "bombay/operation-config/";
    return this.doPost(path, data);
  }

  // Bombay plan
  getBombayPlanList(params) {
    const path = "bombay/plan/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getSortingPlanDetail(id) {
    const path = `bombay/plan/${id}/`;
    return this.doGet(path);
  }

  createBombayPlan(data) {
    const path = "bombay/plan/";
    return this.doPost(path, data);
  }

  updateBombayPlan(id, data) {
    let path = `bombay/plan/${id}/`;
    return this.doPut(path, data);
  }

  deleteBombayPlan(id) {
    let path = `bombay/plan/${id}/`;
    return this.doDelete(path);
  }

  activeBombayPlan(id) {
    let path = `bombay/plan/${id}/active/`;
    return this.doPost(path);
  }

  copyBombayPlan(id) {
    let path = `bombay/plan/${id}/copy/`;
    return this.doPost(path);
  }

  syncBombayPlan(id) {
    let path = `bombay/plan/${id}/sync/`;
    return this.doGet(path);
  }

  getBombayPlanMissConfig(id) {
    const path = `bombay/plan/${id}/miss-station`;
    return this.doGet(path);
  }

  getDestinationInfo(data) {
    let path = `destination_info/`;
    return this.doPost(path, data);
  }

  getBombayChuteConfigs(params) {
    const path = `bombay/plan-chute/`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  createBombayChuteConfig(data) {
    const path = `bombay/plan-chute/`;
    return this.doPost(path, data);
  }

  updateBombayChuteConfig(id, data) {
    let path = `bombay/plan-chute/${id}/`;
    return this.doPut(path, data);
  }

  deleteBombayChuteConfig(id) {
    let path = `bombay/plan-chute/${id}/`;
    return this.doDelete(path);
  }

  getStationsData(params) {
    const path = `station/`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getProvincesData(params) {
    const path = `province/`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getDestinationBySearch(text) {
    const path = `destination/?search=${text}`;
    return this.doGet(path);
  }

  getStationsBySearch(text) {
    const path = `station/?search=${text}`;
    return this.doGet(path);
  }

  // Danh sách lego
  getLegoList(params) {
    const path = "lego/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getLegoDetail(id) {
    const path = `lego/${id}/`;
    return this.doGet(path);
  }

  createLego(data) {
    const path = "lego/";
    return this.doPost(path, data);
  }

  deleteLego(id) {
    let path = `lego/${id}`;
    return this.doDelete(path);
  }

  updateLego(id, data) {
    let path = `lego/${id}/`;
    return this.doPut(path, data);
  }

  // Lego statistic
  getLegoStatistic(params) {
    const path = "statistic/scanner/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Lego plan
  getLegoPlanDetail(id, params) {
    const path = `lego/${id}/plan/`;
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  getLegoPlanConfig(id) {
    const path = `lego-plan/${id}/`;
    return this.doGet(path);
  }

  createLegoPlan(data) {
    const path = "lego-plan/";
    return this.doPost(path, data);
  }

  updateLegoPlan(id, data) {
    let path = `lego-plan/${id}/`;
    return this.doPut(path, data);
  }

  deleteLegoPlan(id) {
    let path = `lego-plan/${id}/`;
    return this.doDelete(path);
  }

  // Flash scanner package
  getFlashScannerPackageList(params) {
    const path = "scan/package-logs/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  exportFlashScannerPackageLogs(params) {
    const path = "scan/package-logs/download/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Flash scanner bag
  getFlashScannerBagList(params) {
    const path = "scan/bags-scan-logs/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  exportFlashScannerBagLogs(params) {
    const path = "scan/bags-scan-logs/download/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  exportFlashScannerBagMissLogs(params) {
    const path = "scan/bags-scan-logs/download-miss/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Flash scanner logs
  getFlashScannerLogsList(params) {
    const path = "scan/scan-logs/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Device sorting
  createDeviceSorting(data) {
    const path = "device-sorting/";
    return this.doPost(path, data);
  }

  updateDeviceSorting(id, data) {
    let path = `device-sorting/${id}/`;
    return this.doPut(path, data);
  }

  getDeviceSortingDetail(id) {
    let path = `device-sorting/${id}/`;
    return this.doGet(path);
  }

  deleteDeviceSorting(id) {
    let path = `device-sorting/${id}/`;
    return this.doDelete(path);
  }

  // Statistic Quantity
  getStatisticQuantity(params) {
    const path = "statistic/barcode/";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }

  // Statistic import export
  getStatisticImExport(params) {
    const path = "statistic/import-export";
    const configs = this.getConfigs({
      params
    });
    return this.doGet(path, configs);
  }
}
